<template>
  <div class="policy-search">
    <div class="policy-control" id="customTable">
      <div class="total-view">
        <div class="total-title-view">
          <h3 class="total-title">您的定制化政策信息</h3>
        </div>
        <div class="total-number">
          <div>
            <img src="../../../../assets/policy/entry.png" alt="" />
            <div class="total-data">
              <p>
                <span>{{ total }}</span
                >条
              </p>
              <p>政策条目</p>
            </div>
          </div>
          <div>
            <img src="../../../../assets/policy/field.png" alt="" />
            <div class="total-data">
              <p>
                <span>{{ domainCount }}</span
                >条
              </p>
              <p>政策领域</p>
            </div>
          </div>
        </div>
      </div>
      <div class="polciy-keyword">
        <span class="control-label">关键词：</span>
        <div class="keywor-view">
          <el-input
            style="width: 239px"
            placeholder="请输入政策关键字"
            v-model="title"
            @keyup.enter.native="handleCurrentChange(1)"
          >
          </el-input>
          <small @click="handleCurrentChange(1)">
            <i class="el-icon-search"></i>
            查询
          </small>
        </div>
      </div>
      <div class="control-item">
        <div class="control-label">政策类别：</div>
        <div class="control-view">
          <small
            v-for="item in policyTypeOption"
            :key="item.id"
            :class="[policyType.includes(item.id) ? 'active' : '']"
            @click="policyChange(item.id, 'policyType')"
          >
            {{ item.name }}
          </small>
        </div>
      </div>
      <div class="control-item" v-show="!arrowState">
        <div class="control-label">支持产业：</div>
        <div class="control-view">
          <small
            v-for="item in supportIndustryOption"
            :key="item.id"
            :class="[supportIndustry.includes(item.id) ? 'active' : '']"
            @click="policyChange(item.id, 'supportIndustry')"
          >
            {{ item.name }}
          </small>
        </div>
      </div>
      <div class="control-item" v-show="!arrowState">
        <div class="control-label">支持方式：</div>
        <div class="control-view">
          <small
            v-for="item in supporModeList"
            :key="item.id"
            :class="[supporMode.includes(item.id) ? 'active' : '']"
            @click="policyChange(item.id, 'supporMode')"
          >
            {{ item.name }}
          </small>
        </div>
      </div>
      <div class="control-item" v-show="!arrowState">
        <div class="control-label">政策来源：</div>
        <div class="control-view">
          <small
            v-for="item in policySourceOption"
            :key="item.id"
            :class="[policySource.includes(item.id) ? 'active' : '']"
            @click="policyChange(item.id, 'policySource')"
          >
            {{ item.name }}
          </small>
        </div>
      </div>
      <div class="control-item" v-show="!arrowState">
        <div class="control-label">政策状态：</div>
        <div class="control-view">
          <small
            v-for="item in policyStateList"
            :key="item.id"
            :class="[policyState.includes(item.id) ? 'active' : '']"
            @click="policyChange(item.id, 'policyState')"
          >
            {{ item.name }}
          </small>
        </div>
      </div>
      <div class="control-item" v-show="!arrowState">
        <div class="control-label">政策匹配度：</div>
        <div class="control-view">
          <div class="invest-view">
            <el-input
              style="width: 99px"
              v-model="start"
              placeholder="起始"
              @input="numberTemplate($event, 'start')"
              @blur="startNumChange"
              :max="100"
            ></el-input>
            <span>-</span>
            <el-input
              style="width: 99px"
              v-model="end"
              placeholder="结束"
              @input="numberTemplate($event, 'end')"
              @blur="startNumChange"
              :max="100"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="control-btn" :class="[arrowState ? 'active' : '']">
        <el-button class="system-clean" @click="policyClear"> 清空 </el-button>
        <el-button
          class="system-search"
          type="primary"
          @click="handleCurrentChange(1)"
        >
          查询
        </el-button>
      </div>
      <small
        :class="[arrowState ? 'arrow-view' : 'arrow-view active']"
        @click="arrowChange"
      >
        <img src="../../../../assets/arrow.png" />
      </small>
    </div>
    <div
      class="policy-main"
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <section class="custom-table">
        <div class="custom-table-slider" v-if="!noData">
          <div
            class="table-list-item"
            v-for="(item, index) in tableData"
            :key="index"
            @click="matchInfo(item)"
          >
            <div class="policyTitle">
              <h3>
                {{ item.title }}
              </h3>
              <div class="custom-tags">
                <small>匹配度：{{ item.score }}</small>
              </div>
              <span class="info"
                >查看详情 <i class="el-icon-arrow-right"></i
              ></span>
            </div>
            <div class="list-item-type">
              <small>
                政策类别：<span>{{ item.type }}</span>
              </small>
              <small>
                发文单位：<span>{{ item.issueDepartment || "--" }}</span>
              </small>
              <small :title="item.supportWay">
                支持方式：<span>{{ item.supportWay }}</span>
              </small>
            </div>
            <div class="list-item-type">
              <small>
                发布日期：<span>{{ item.issueDate }}</span>
              </small>

              <small>
                状态：<span>
                  {{
                    getDateState(
                      item.declareDateStart,
                      item.declareDateEnd,
                      item.declareDateType
                    )
                  }}
                </span>
              </small>

              <small></small>
            </div>
          </div>
        </div>
        <div class="custom-empty" v-else>
          <el-empty
            description="暂无数据"
            :image="image"
            :image-size="160"
          ></el-empty>
        </div>
      </section>
      <div style="padding: 15px; text-align: center" v-if="!noData">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="匹配详情"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="776px"
    >
      <div class="dialog-view">
        <div class="table-header-">
          <p>
            <small>序号</small><small>申请条件</small><small>企业资质</small
            ><small>匹配结果</small>
          </p>
        </div>
        <div class="table-body-">
          <p v-for="(item, index) in matchTableData" :key="index">
            <small>{{ index + 1 }}</small>
            <small>{{ item.key1 || "--" }}</small>
            <small>{{ item.key2 || "--" }}</small>
            <small>
              <i class="el-icon-check" v-if="item.result"></i>
              <i v-else class="el-icon-close"></i>
            </small>
          </p>
          <p>
            <small style="flex: 1;width: 0;text-align: center;">匹配得分</small>
            <small style="width: 80px;flex: none;">{{ score }}</small>
          </p>
        </div>
        <!-- <el-table
          ref="multipleTable"
          :data="matchTableData"
          :stripe="true"
          tooltip-effect="dark"
          style="width: 100%; font-size: 14px;"
          class="system-table-v"
        >
          <el-table-column type="index" width="50" label="序号">
          </el-table-column>
          <el-table-column label="申请条件">
            <template slot-scope="scope">
              <p class="custom-policy-title" :title="scope.row.title">
                {{ scope.row.title || "--" }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="企业资质">
            <template slot-scope="scope">
              {{ scope.row.idt || "--" }}
            </template>
          </el-table-column>
          <el-table-column label="匹配结果">
            <template slot-scope="scope">
              {{ scope.row.auditDate || "--" }}
            </template>
          </el-table-column>
        </el-table> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDropDown } from "@/api/app";
import { getPolicyMatchTable, policyMatchInfo } from "@/api/policy";
import { encrypt, FunGetDateStr } from "@/utils/index";
export default {
  name: "policySearch",
  data() {
    return {
      matchTableData: [],
      dialogVisible: false,
      policySourceOption: [],
      policyTypeOption: [],
      supportIndustryOption: [],
      supporModeList: [],
      policyStateList: [
        { name: "全部", id: "All" },
        { name: "申报中", id: "1" },
        { name: "申报结束", id: "2" }
      ],
      policySource: ["All"],
      policyType: ["All"],
      supportIndustry: ["All"],
      supporMode: ["All"],
      policyState: ["All"],
      start: 60,
      end: 100,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      title: "",
      loading: false,
      arrowState: true,
      noData: false,
      image: require("../../../../assets/noData1.png"),
      state: {
        no: "待领取",
        2: "审核中",
        3: "已通过",
        4: "退回修改"
      },
      toLogin: false,
      score: 0,
      domainCount: 0
    };
  },
  components: {},
  beforeMount() {
    this.getDropDown("policySource", "policySourceOption");
    this.getDropDown("policyType", "policyTypeOption");
    this.getDropDown("userIndustry", "supportIndustryOption");
    this.getDropDown("supportWay", "supporModeList");
  },
  mounted() {
    this.title = this.$route.query.value;
    this.getPolicyMatchTable();
  },
  methods: {
    /**政策匹配详情 */
    matchInfo(item) {
      this.getpolicyMatchInfo(item.infoId);
      this.dialogVisible = true;
    },
    /**政策已发布状态 */
    getDateState(startTime, endTime, type) {
      if (type == 2) return "申报中";
      const startTime1 = new Date(startTime).getTime();
      const endTime1 = new Date(endTime).getTime();
      let dateTime = new Date(FunGetDateStr(0)).getTime();
      if (!startTime && !endTime) {
        return "申报中";
      }
      if (dateTime < startTime1) {
        return "申报中";
      } else if (dateTime > endTime1) {
        return "申报结束";
      } else {
        return "申报中";
      }
    },
    arrowChange() {
      this.arrowState = !this.arrowState;
    },
    policyClear() {
      this.policySource = ["All"];
      this.policyType = ["All"];
      this.supportIndustry = ["All"];
      this.supporMode = ["All"];
      this.policyState = ["All"];
      this.title = "";
      this.start = "";
      this.end = "";
    },
    /**政策条件请求 */
    async getDropDown(type, option) {
      let { data } = await getDropDown({ type: type });
      data.unshift({ name: "全部", id: "All" });
      this[option] = data;
    },
    policyChange(id, list) {
      this.arrowState = false;
      if (id == "All") {
        this[list] = ["All"];
        return false;
      } else {
        this[list] = this[list].filter(item => item != "All");
      }
      if (this[list].includes(id)) {
        this[list] = this[list].filter(item => item != id);
        if (this[list].length <= 0) {
          this[list] = ["All"];
        }
      } else {
        this[list].push(id);
      }
    },
    policyStateChange(id) {
      if (this.policyState == id) {
        this.policyState = "";
      } else {
        this.policyState = id;
      }
    },
    /**政策详情 */
    async getpolicyMatchInfo(id) {
      let { data } = await policyMatchInfo({ id });
      this.matchTableData = JSON.parse(data.expand);
      this.score = data.score;
    },
    /**列表 */
    async getPolicyMatchTable(type) {
      this.loading = true;
      let { data } = await getPolicyMatchTable(this.getParams());
      this.loading = false;
      if (data && data?.page?.records.length > 0) {
        this.tableData = data.page.records;
        this.total = data.page.total;
        this.domainCount = data.domainCount;
        this.noData = false;
      } else {
        this.tableData = [];
        this.noData = true;
        this.total = 0;
        this.domainCount = 0;
      }
      if (type) {
        this.$nextTick(() => {
          document
            .getElementById("customTable")
            .scrollIntoView({ behavior: "smooth", block: "start" });
        });
      }
    },
    getParams() {
      let {
        policySource,
        policyType,
        supportIndustry,
        supporMode,
        policyState,
        start,
        end
      } = this;
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        title: this.title,
        policyStatus: 3,
        start: start,
        end: end
      };
      if (!policySource.includes("All")) {
        params.source = policySource.join(",");
      }
      if (!policyType.includes("All")) {
        params.type = policyType.join(",");
      }
      if (!supportIndustry.includes("All")) {
        params.supportIndustry = supportIndustry.join(",");
      }
      if (!supporMode.includes("All")) {
        params.supportWay = supporMode.join(",");
      }
      if (!policyState.includes("All")) {
        params.policyState = policyState.join(",");
      }
      return params;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPolicyMatchTable(true);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getPolicyMatchTable(true);
    },
    policyInfo(item) {
      let { href } = this.$router.resolve({
        path: "/policy/policyInfo",
        query: { id: encrypt(item.id) }
      });
      window.open(href);
    },
    startNumChange() {
      let { start, end } = this;
      if (Number(start) && Number(end)) {
        if (Number(end) < Number(start)) {
          this.end = start;
          this.start = end;
        }
      }
    },
    numberTemplate(data, item) {
      let num = data.replace(/^(0+)|[^\d]+/g, "");
      if (Number(num) > 100) {
        num = "";
      }
      this[item] = num;
    }
  }
};
</script>

<style lang="less" scoped>
.custom-table {
  min-height: 300px;
}
.policy-search {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  & > div {
    background: #fff;
    border-radius: 5px;
  }
  & .policy-main {
    flex: 1;
    height: 0;
    display: flex;
    flex-direction: column;
    & > section {
      flex: 1;
      height: 0;
    }
  }
}
.policy-control {
  padding: 15px 30px;
  margin-bottom: 20px;
  position: relative;
}
.control-btn {
  text-align: right;
  &.active {
    padding-top: 10px;
  }
}
.control-item {
  display: flex;
  flex-direction: row;
  & .control-label {
    font-size: 14px;
    color: #312f2f;
    line-height: 30px;
    width: 85px;
    text-align: right;
  }
  & .control-view {
    width: 0;
    flex: 1;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    & small {
      padding: 6px 18px;
      background: #ffffff;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      margin-right: 15px;
      margin-bottom: 15px;
      color: #606266;
      font-size: 14px;
      cursor: pointer;
      &:hover {
        border: 1px solid #2d77fc;
        color: #2d77fc;
      }
      &.active {
        background: #2d77fc;
        border: 1px solid #2d77fc;
        color: #fff;
      }
    }
  }
}
.polciy-keyword {
  display: flex;
  align-items: center;
  padding: 10px 0 30px 0;

  & span {
    width: 85px;
    font-size: 14px;
    color: #312f2f;
    text-align: right;
  }
  .keywor-view {
    border: 1px solid #2d77fc;
    border-radius: 4px;
    display: flex;
    align-items: center;
    & small {
      cursor: pointer;
      height: 38px;
      line-height: 38px;
      font-size: 14px;
      background: #2d77fc;
      color: #fff;
      padding: 0px 20px;
    }
    ::v-deep {
      .el-input__inner {
        border: none;
        height: 38px;
        line-height: 38px;
      }
    }
  }
}
.custom-table-slider {
  padding: 30px 30px 0 30px;
}
.custom-policy-title {
  &:hover {
    color: #1d6cea;
    cursor: pointer;
  }
}
.arrow-view {
  position: absolute;
  width: 160px;
  height: 32px;
  bottom: -3px;
  left: 50%;
  margin-left: -105px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
  & img {
    transition: all 0.2s ease-in-out;
  }
  &.active {
    img {
      transform: rotate(-180deg);
    }
  }
}
.table-list-item {
  border: 1px solid #eeeeee;
  margin-bottom: 20px;
  padding: 20px;
  cursor: pointer;
  &:hover {
    background: rgba(243, 249, 254, 1);
    & h3 {
      color: #2d77fc;
    }
  }
  & h3 {
    color: rgba(49, 47, 47, 1);
    font-size: 16px;
    margin: 0;
    &:hover {
      cursor: pointer;
    }
  }
  & .list-item-type {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-bottom: 15px;
    &:last-of-type {
      padding-bottom: 0;
    }
    small {
      width: 25%;
      flex: 1;
      font-size: 14px;
      color: rgba(169, 169, 169, 1);
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    span {
      color: rgba(49, 47, 47, 1);
    }
  }
}
.policyTitle {
  padding-bottom: 15px;
  position: relative;
  & .info {
    position: absolute;
    right: 0;
    top: 0;
    color: #2d76fc;
    font-size: 14px;
  }
}
.total-title-view {
  display: flex;
  justify-content: center;
  padding: 22px 0 0 20px;
  & h3 {
    font-size: 20px;
    color: #2b2b2b;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: -15px;
      right: 0;
      height: 4px;
      background: url("../../../../assets/policy/title_bottom.png") no-repeat
        center center;
      background-size: 100% 100%;
    }
  }
}
.total-number {
  display: flex;
  justify-content: center;
  padding: 50px 0 30px 0;
  & > div {
    display: flex;
    align-items: center;
    &:first-of-type {
      margin-right: 120px;
    }
  }
}
.total-data {
  margin-left: 15px;
  & p {
    font-size: 18px;
    color: #2b2b2b;
    &:first-of-type {
      padding-bottom: 14px;
      font-size: 14px;
      & span {
        font-size: 28px;
        color: #2d77fc;
        font-family: "qingke";
        padding-right: 4px;
      }
    }
  }
}
.invest-view {
  display: flex;
  align-items: center;
  & span {
    padding: 0 5px;
  }
}
.custom-tags {
  display: flex;
  margin: 10px 0 5px 0;
  & small {
    background: #53d295;
    border-radius: 11px;
    font-size: 14px;
    color: #fff;
    padding: 4px 14px;
  }
}
.table-header-,
.table-body- {
  & p {
    display: flex;
    & small {
      border: 1px solid rgb(231, 231, 231);
      margin-top: -1px;
      margin-right: -1px;
      padding: 8px 8px !important;
      font-size: 14px;
      &:nth-of-type(1) {
        width: 80px;
        text-align: center;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }
      &:nth-of-type(2) {
        flex: 1;
        width: 0;
        text-align: center;
        padding: 0;
      }
      &:nth-of-type(3) {
        flex: 1;
        width: 0;
        text-align: center;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }
      &:nth-of-type(4) {
        width: 80px;
        text-align: center;
        display: inline-flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
.el-icon-check {
  color: #2d77fc;
  font-weight: bold;
}
.el-icon-close {
  color: rgb(248, 58, 58);
  font-weight: bold;
}
</style>
